import React, {useState} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {mr, positionRelative} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {quickViewPoiClickOnElement} from "../../tracking/algolytics_hits/quick_view_modal_hits";
import {gtmQuickViewModalElement} from "../../tracking/google_tag_manager/gtm_event_quick_view_modal";

interface IProps {
    icon: React.ReactNode;
    title: string;
    name?: string;
    distance?: number;
    id: number;
}

export const PoiItemWithTooltip = (props: IProps) => {
    const {icon, title, name, distance, id} = props;
    const [hover, setHover] = useState(false);
    const roundedDistance = Math.round(distance ?? 0);
    const onMouseEnter = () => {
        quickViewPoiClickOnElement(title);
        gtmQuickViewModalElement("poi");
        setHover(true);
    };
    const onMouseLeave = () => setHover(false);

    return (
        <div css={[mr(3), positionRelative]}>
            <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                {icon}
            </div>

            <Tooltip hover={hover} index={id}>
                <Text as="div" variant="info_txt_1">
                    {title}
                </Text>
                <Text as="div" variant="info_txt_2">
                    {name} -{" "}
                    <Text as="span" variant="info_txt_2" strong>
                        {roundedDistance}m
                    </Text>
                </Text>
            </Tooltip>
        </div>
    );
};

interface ITooltip {
    hover: boolean;
    index: number;
}

const Tooltip = styled.div<ITooltip>`
    display: flex;
    flex-direction: column;
    opacity: 0;
    height: 0;
    overflow: hidden;
    position: absolute;
    //prevent overflowing icons from pictograms
    z-index: 1;
    //tooltip from poi > 2 will have other properties to prevent overflow
    left: ${(props) => (props.index > 2 ? "-11rem" : "-1.5rem")};
    top: 3.8rem;
    width: 20rem;
    padding: 1.8rem;
    background-color: ${(props) => props.theme.colors.gray[200]};
    border-radius: 0.4rem;

    &::before {
        content: "";
        position: absolute;
        top: -1rem;
        //tooltip from poi > 2 will have other properties to prevent overflow
        left: ${(props) => (props.index > 2 ? "10.6rem" : "1.15rem")};
        width: 0;
        height: 0;
        border-left: 1.5rem solid transparent;
        border-right: 1.5rem solid transparent;
        border-bottom: 1rem solid ${(props) => props.theme.colors.gray[200]};
    }

    @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
        left: -1.5rem;

        &::before {
            left: 1.15rem;
        }
    }

    ${(props) =>
        props.hover &&
        css`
            opacity: 1;
            height: auto;
            overflow: visible;
            transition: opacity 500ms ease-in;
        `};
`;
import React, {useState} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {mr, positionRelative} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {quickViewPoiClickOnElement} from "../../tracking/algolytics_hits/quick_view_modal_hits";
import {gtmQuickViewModalElement} from "../../tracking/google_tag_manager/gtm_event_quick_view_modal";

interface IProps {
    icon: React.ReactNode;
    title: string;
    name?: string;
    distance?: number;
    id: number;
}

export const PoiItemWithTooltip = (props: IProps) => {
    const {icon, title, name, distance, id} = props;
    const [hover, setHover] = useState(false);
    const roundedDistance = Math.round(distance ?? 0);
    const onMouseEnter = () => {
        quickViewPoiClickOnElement(title);
        gtmQuickViewModalElement("poi");
        setHover(true);
    };
    const onMouseLeave = () => setHover(false);

    return (
        <div css={[mr(3), positionRelative]}>
            <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                {icon}
            </div>

            <Tooltip hover={hover} index={id}>
                <Text as="div" variant="info_txt_1">
                    {title}
                </Text>
                <Text as="div" variant="info_txt_2">
                    {name} -{" "}
                    <Text as="span" variant="info_txt_2" strong>
                        {roundedDistance}m
                    </Text>
                </Text>
            </Tooltip>
        </div>
    );
};

interface ITooltip {
    hover: boolean;
    index: number;
}

const Tooltip = styled.div<ITooltip>`
    display: flex;
    flex-direction: column;
    opacity: 0;
    height: 0;
    overflow: hidden;
    position: absolute;
    //prevent overflowing icons from pictograms
    z-index: 1;
    //tooltip from poi > 2 will have other properties to prevent overflow
    left: ${(props) => (props.index > 2 ? "-11rem" : "-1.5rem")};
    top: 3.8rem;
    width: 20rem;
    padding: 1.8rem;
    background-color: ${(props) => props.theme.colors.gray[200]};
    border-radius: 0.4rem;

    &::before {
        content: "";
        position: absolute;
        top: -1rem;
        //tooltip from poi > 2 will have other properties to prevent overflow
        left: ${(props) => (props.index > 2 ? "10.6rem" : "1.15rem")};
        width: 0;
        height: 0;
        border-left: 1.5rem solid transparent;
        border-right: 1.5rem solid transparent;
        border-bottom: 1rem solid ${(props) => props.theme.colors.gray[200]};
    }

    @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
        left: -1.5rem;

        &::before {
            left: 1.15rem;
        }
    }

    ${(props) =>
        props.hover &&
        css`
            opacity: 1;
            height: auto;
            overflow: visible;
            transition: opacity 500ms ease-in;
        `};
`;
